import { defineComponent as _defineComponent } from 'vue'
import { inject, onMounted, onBeforeUnmount } from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  PGCode,
  PROVIDE_KEY_REMOVE_LOADING_IMAGE,
  PROVIDE_KEY_SHOW_LOADING_IMAGE,
  RemoveLoadingImage,
  RouterName,
  ShowLoadingImage,
} from "@/types";
import { useBookStore } from "@/stores/bookStore";


const __default__ = {
  name: "BookFail",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const router = useRouter();
const bookStore = useBookStore();

const showLoadingImage = inject(
  PROVIDE_KEY_SHOW_LOADING_IMAGE
) as ShowLoadingImage;
const removeLoadingImage = inject(
  PROVIDE_KEY_REMOVE_LOADING_IMAGE
) as RemoveLoadingImage;

const moveToMainLogin = (bookFail: boolean, resultCode: string) => {
  router.replace({
    name: RouterName.MainLogin,
    query: { bookFail: bookFail.toString(), resultCode },
  });
};

onMounted(async () => {
  showLoadingImage();

  const { bookUid, payUid, pgCode, resultCode } = route.query as {
    bookUid: string;
    payUid: string;
    pgCode: string;
    resultCode: string;
  };

  if (pgCode === PGCode.KakaoPay) {
    await bookStore.failKakaoPay(payUid, bookUid);
  } else if (pgCode === PGCode.KCP) {
    await bookStore.failKcp(payUid, bookUid);
  } else {
    /** do nothing */
  }

  moveToMainLogin(true, resultCode);
});

onBeforeUnmount(() => {
  removeLoadingImage();
});

const __returned__ = { route, router, bookStore, showLoadingImage, removeLoadingImage, moveToMainLogin }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})